// extracted by mini-css-extract-plugin
export default {"callout":"Callout-module__callout___bjZVU"};